export default "__VITE_ASSET__gfD$$EGs__"